<template>
          <div v-if="isSlideImages" class="col-sm-6 col-md-6 col-lg-6">
            <Carousel :controls="false" :interval="3500">
              <Slide
                :key="index"
                v-for="(filename, index) in selectedSlideImages"
              ><img
                :src="app_root + '/assets/createplus/img/template/slideimage/' + templateid + '/' + filename"
                class="img-responsive center-block"
              /></Slide>
            </Carousel>
          </div>
</template>

<script>
import { mapState } from "vuex";
import { Carousel, Slide } from "uiv";
export default {
  name: "CreatePlusTemplateSlide",
  props: {
    categoryid: String,
    subcategoryid: String,
    templateid: String,
  },
  components: {
    Carousel,Slide
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    ...mapState('createplusTemplates', ['createplusCategories', 'createplusCategoriesStatus', 'createplusTemplates', 'createplusTemplatesStatus']),

    selectedSlideImages: function () {
      const template = this.createplusTemplates.find(template => template.templateID === this.templateid);
      return (template || {}).slideImages;
    },
    isSlideImages: function () {
      const slideImages = this.selectedSlideImages
      return slideImages && slideImages.length > 0
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>